import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom"
import MaterialTable from "material-table";
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import {baseUrl} from '../../../config';
import DatePicker from "react-datepicker";
// import './takerate.css';
import moment from 'moment'

import "react-datepicker/dist/react-datepicker.css";
import {clickColor,inArray} from './../../../library/util';
import CloseIcon from '@mui/icons-material/Close';
import SummarizeIcon from '@mui/icons-material/Summarize';
import './firstmile.css'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Loader from 'react-loader-spinner';
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import Typography from "@material-ui/core/Typography";
import {formatNumberWithToFixed} from '../ProfitabilityDiagnosis/js/commanFn';
import AddIcon from '@mui/icons-material/Add';
import axiosIntance from '../../../helper/axios';

import { checkAccess, FEATURES } from '../../../library/auth'

const animatedComponents = makeAnimated();


const MyNewTitle = ({ text, variant }) => (
  <Typography
    variant={variant}
    style={{
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }}
  >
    {text}
  </Typography>
);
const style = {
  position: 'absolute',
  
  // left: '50%',
  right:'-22%',
  padding:'3px',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  align:'right',
  top: '26%',
  // top: '80%',
  width: '42%',
  height: '20%',
  maxHeight:'550px',
  overflowY: 'auto'
  
};

const colourStyles = {
  menuList: styles => ({
      ...styles,
      background: 'white'
  }),
  option: (styles, {isFocused, isSelected}) => ({
      ...styles,
      background: isFocused
          ? 'lightblue'
          : isSelected
              ? '#2a7bc0'
              : undefined,
      zIndex: 1
  }),
  menu: base => ({
      ...base,
      zIndex: 100
  })
  }
  const style_advanced = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };



  const AddIconClasses={ color: '#337ab7',fontSize:'30px',marginLeft:'128px',marginTop:"-15px",cursor: 'pointer' };

const styleCloseIcon={
  margin:'-27px'
}


function FirstmileCostAnalysis() {
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const { type } = useParams()
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [summary,setSummary]=useState([]);
    const [showSummaryDiv,setShowSummaryDiv]=useState(false)
    const [gas,setGas]=useState('');


   

    const [group,setgroup]=useState('');
    const [groupArray,setgroupArray]=useState([]);
    

    const selectInputRef = useRef();
    const selectInputRefInputFilter=useRef();
    const [filterLabel,setFilterLabel]=useState([])
    const [filterValue,setFilterValue]=useState('')
    const [filterArray,setFilterArray]=useState([]);


    const typeTable='firstmile';

    const [selectLabelHeader,setSelectLabelHeader]=useState([
      {label:"invoice_date",value:"invoice_date",group:"invoice_date"},
      {label:"invoice_number",value:"invoice_number",group:"invoice_number"},
      {label:"pickup_date",value:"pickup_date",group:"pickup_date"},
      {label:"tracking_number",value:"tracking_number",group:"tracking_number"},
      {label:"total_charge",value:"total_charge",group:"total_charge"},
      {label:"product_1",value:"product_1",group:"product_1"},
      {label:"product_2",value:"product_2",group:"product_2"},
      {label:"label_number",value:"label_number",group:"label_number"},
      {label:"fm_base_rate",value:"fm_base_rate",group:"fm_base_rate"},
      {label:"zone",value:"zone",group:"zone"},
      {label:"weight_oz",value:"weight_oz",group:"weight_oz"},
      {label:"weight_lbs",value:"weight_lbs",group:"weight_lbs"},
      {label:"billing_ref",value:"billing_ref",group:"billing_ref"},
      {label:"billing_ref2",value:"billing_ref2",group:"billing_ref2"},
      {label:"recipient_name",value:"recipient_name",group:"recipient_name"},
      {label:"recipient_address",value:"recipient_address",group:"recipient_address"},
      {label:"recipient_address2",value:"recipient_address2",group:"recipient_address2"},
      {label:"recipient_city",value:"recipient_city",group:"recipient_city"},
      {label:"recipient_state",value:"recipient_state",group:"recipient_state"},

      {label:"recipient_country",value:"recipient_country",group:"recipient_country"},
      {label:"recipient_zip",value:"recipient_zip",group:"recipient_zip"},
      {label:"fuel",value:"fuel",group:"fuel"},


    ]);
    const loadFilterLabel=(inputValue)=>
  {
    let tempCategory=selectLabelHeader;
    return new Promise((resolve) => {
      resolve(tempCategory.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
       ))
    });
   // loanGroupCategoryFnChild('1');
  }


  const handleChangeFilter=(e)=>{
    if(e.target.value!=undefined){
      setFilterValue(e.target.value);
    }
  }
  
  const addFilter=()=>{
    console.log('addFilter',group,filterValue)
    if(group!='' && filterValue!=''){
      let tempObj={field:group,value:filterValue};  
        filterArray.push(tempObj);
        setFilterArray(filterArray);
        setFilterValue('')
    }
  }
  const deleteAdvancedFilterFn = (item,index) =>{
    console.log(filterArray[index])
   const arr = filterArray.filter((item,j) => j!=index);
   console.log(arr)
   setFilterArray(arr);
  }

  const handleChange=( target )=> {
    if(target!=undefined){
      setgroup(target.value);
    }
}



   
    

    console.log(type);
    let midTitle='FirstMile Cost Analysis';

    const reportName=`${midTitle}`
    // var date = new Date();
    // date.setDate(date.getDate() - 2);
    // console.log(date)
    // console.log(new Date())
    const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    
    const [selectedrowList,setSelectedRowList]=useState([]);
    const handleSignOut = () => {
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }

      const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }
  
   
    if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
      history.push('/');
    }

    checkUserTypeFn(history);

    function checkUserTypeFn(history){
      const userdata=JSON.parse(localStorage.getItem('userdata'));
      const usertype=userdata.type;
      console.log('in check usertype fn');
      console.log(usertype)
      if (!checkAccess(FEATURES.firstmile_cost_analysis)) {
        history.push('/');
      }
    }
  
    const [reportData,setReportData]=useState([])
    const [loader,setLoader]=useState(false)
    
    const [message, setMessage] = useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    const [successMsg,setSuccessMsg]=useState('')
    useEffect(() => {
      //fetchApi();
      return () => {
        console.log('un subscribe')
        ResetFilter();
        setSummary([])
        setShowSummaryDiv(false)
      }
  
      
  
    }, [midTitle])
    
    const ResetFilter = () => {
      setMessage('')
     
      setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
      setReportData([]);
    }
   
  const fetchApi = () =>{
    console.log('here check')
    console.log(startDate)
    if(startDate==null){
      setMessage('Date must not be blank')
      return false;
    }else{
      setMessage('')
    }
    setLoader(true)
    let filterString='';
    console.log(filterArray);
    filterArray.forEach((i,j)=>{
      filterString+=`${i.field}=${i.value}*`
    })
    
    axiosIntance.get(baseUrl+`/reports/firstmilecostanalysis/?startdate=`+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&gas="+gas+"&filter="+filterString, {}).then(response => {
  
        if (response.data.result.length > 0) {    
          console.log(response.data.result) 
         // setOpen(true)
          
         getSummary(response.data.result);

         response.data.result.forEach((i,j)=>{
          console.log(i);
          i.fm_charge="$"+formatNumberWithToFixed(i.fm_charge);
          i.expected_charge="$"+formatNumberWithToFixed(i.expected_charge);
          i.rates_difference="$"+formatNumberWithToFixed(i.rates_difference);
          i.actual_fm_cost="$"+formatNumberWithToFixed(i.actual_fm_cost);
          i.expected_total_cost="$"+formatNumberWithToFixed(i.expected_total_cost);
          });

          setReportData(response.data.result);

          
          
          //console.log(response.data.result);

          console.log(reportData)
          setLoader(false)
          //setSuccessMsg('Data')
        } else {
          setLoader(false)
          setReportData([]);
          setShowSummaryDiv(false)
          //setMessage('No data');
          console.log(45)
         // history.push('/home');
        }
  
      }).catch(error => {
        setLoader(false)
        setMessage('Something went wrong');
      });
  }

  const fetchApiDownload = () =>{
    let filterString='';
    console.log(filterArray);
    filterArray.forEach((i,j)=>{
      filterString+=`${i.field}=${i.value}*`
    })
    const token = window.localStorage.getItem('token');
      window.location.href=baseUrl+`/reports/firstmilecostanalysis/download?startdate=`+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&gas="+gas+"&filter="+filterString+"&token="+token;
  }

  const getSummary=(result)=>{
    console.log('=====getSummary calling =====' )
    let arraySumary={};
    arraySumary.actual_fm_cost=0;
    arraySumary.total_cost=0;
    result.forEach(element => {
        console.log(element);
        arraySumary.actual_fm_cost+=element.actual_fm_cost;
        arraySumary.total_cost+=element.expected_total_cost;

    });
    arraySumary.actual_fm_cost=roundToTwo(arraySumary.actual_fm_cost)
    arraySumary.total_cost=roundToTwo(arraySumary.total_cost)
    arraySumary.diff=roundToTwo(arraySumary.actual_fm_cost-arraySumary.total_cost);
    summary[0]=arraySumary;
    setSummary(summary)
    console.log(summary)
    //setShowSummaryDiv(true)
    summary.length>0?setShowSummaryDiv(true):setShowSummaryDiv(false)

    // console.log('here 210='+summary[0])
    // console.log(summary[0]);
    // console.log(summary[0]['actual_fm_cost'])
    // console.log(summary[0]['diff'])
    // console.log(summary[0]['total_cost'])
  }
  const preventPasteNegative = (e) => {
    const clipboardData = e.clipboardData || window.clipboardData;
    const pastedData = parseFloat(clipboardData.getData('text'));

    if (pastedData < 0) {
        e.preventDefault();
    }
};
const preventMinus = (e) => {
  console.log(e.code)
  if (e.code === 'Minus') {console.log('in Minus')
      e.target.value=0;
  }else if(e.target.value!=''){
    let value=parseInt(e.target.value);
    if(value>10){
      e.target.value=10;
    }
  }
};

  


  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }
   
   
    return (
  
      <div id="wrapper" className>
        <Sidebar />
        <Header handleSignOut={handleSignOut} />



  <div></div> 
  <div></div>
  <div></div> 
  <div></div>
     
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>
  
  
  
  
    
  
  
    <section id="content-wrapper">

<div classname="advancedFilterSection">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
     <Box sx={style_advanced}>


<label>Firstmile Header</label>
<label className='filterValueStyle'>Filter Values</label> 
<div class="input-bar">

<div className="input-bar-item width100">

<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChange(e)} 
  cacheOptions
  defaultOptions
  maxMenuHeight={250} 
  className="widthSelectInput"
  classNamePrefix="select"
    styles={colourStyles}
  getOptionLabel={(e) => e.value}
  getOptionValue={(e) => e.value}
  loadOptions={loadFilterLabel}        
/>
</div>

<>

&nbsp;&nbsp;&nbsp;
<div className="input-bar-item width100">
  <input type='text'
     ref={selectInputRefInputFilter}
     className='width140x filterValue'
     placeholder="Value"
     onChange={e => handleChangeFilter(e)} 
     />
  <AddIcon style={AddIconClasses} onClick={addFilter}/>
</div>
</>

 
<div className="input-bar-item width100">
<div className="input-bar-item closeModel closeIconCommon"> 
<CloseIcon className='closeIcon' onClick={handleClose}/>
</div>
</div>

</div>

<div className="input-bar-item width100">
<div className="FilterSection">

    {filterArray.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}
</div>

</div>




     </Box>
     </Modal>
</div>

   

    <label>Date of invoice</label>
    {/* <label className='endDateStyle'>End Date</label> */}
    <div className="input-bar">
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd"
      selected={startDate}
      className='width140x'
      onChange={(date) => setStartDate(date)}
      placeholder='Start Date'

      
      timeFormat="p"
      
      />

    </div>
    
   
 
     <div className="input-bar-item width100">
    
    {/* <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      selected={endDate}
      className='width140x'
      onChange={(date) => setEndDate(date)}
      placeholder='End Date'

      showTimeSelect
      timeFormat="p"
      timeIntervals={15}

      /> */}
    <input 
     name='gas'
    //  pattern="[0-9.]+" 
     pattern="^[0-9\b]+$" 
     type="number"
     value={gas}
     className='width50x'
     placeholder="Gas"
     min="0"
     max="10"
     
     onPaste={preventPasteNegative}
     //onKeyPress={preventMinus}
     onKeyUp={preventMinus}
     onChange={e => setGas(e.target.value)}
     />
      
    </div> 
   
   
   &nbsp;&nbsp;&nbsp;
   <div className="input-bar-item">
    <button type="button"  onClick={handleOpen}  className="btn btn-primary">Advanced Filter</button>
   
    </div>
    <div className="input-bar-item">
    <button type="button"  onClick={fetchApi} className="btn btn-primary">Run Report</button>
   
    </div>
    <div className='input-bar-item'>
    <button type="button"  onClick={ResetFilter} className="btn btn-primary">Reset</button>
    </div>

    

    {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}

      <div className='downloadReportBtn'>
        {
          
          <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>
         
        }
       
      </div>
     
      

     
  </div>
  {/* {summary.length>0 &&
  <div className='summaryIconDiv'>
    <SummarizeIcon className='summaryIcon' onClick={handleOpen}/>
   </div>
} */}
<div className="FilterSection">
  
  {filterArray.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">{item.field} = {item.value }</span>
       <span  onClick={(event) => deleteAdvancedFilterFn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}




    
  </div>

  {loader ?
  <div className='loaderDiv'>  
  <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> : 
  
      <>
          <MaterialTable style={{ maxWidth: '58%' }}
          // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}

          onRowClick={((evt, selectedRow) => 
            setRowBackground(selectedRow)
            )}
            columns={[
              { title: "Ship.Type", field: "ship_type",
              cellStyle:(e,rowdata)=>{
                if(rowdata.last==1){
                  return {fontWeight:'bold'}
                }
              }
             },
              { title: "Zone", field: "zone", 
              cellStyle:(e,rowdata)=>{
                if(rowdata.last==1){
                  return {fontWeight:'bold'}
                }
              }
            },{ title: "Weight", field: "weight_oz", 
            cellStyle:(e,rowdata)=>{
              if(rowdata.last==1){
                return {fontWeight:'bold'}
              }
            }
          },
              { title: "FM.Charge", field: "fm_charge",
            
            
              cellStyle:(e,rowdata)=>{
                if(rowdata.last==1){
                  return {fontWeight:'bold'}
                }
              }},
              { title: "Expected.Charge", field: "expected_charge", 
              cellStyle:(e,rowdata)=>{
                if(rowdata.last==1){
                  return {fontWeight:'bold'}
                }
              }
            },
            { title: "Rates.Difference", field: "rates_difference", 
            cellStyle:(e,rowdata)=>{
              if(rowdata.last==1){
                return {fontWeight:'bold'}
              }
            }
          },
          { title: "Ship.Count", field: "ship_count", 
          cellStyle:(e,rowdata)=>{
            if(rowdata.last==1){
              return {fontWeight:'bold'}
            }
          }
        },
        { title: "Actual.FM.Cost", field: "actual_fm_cost", 
        cellStyle:(e,rowdata)=>{
          if(rowdata.last==1){
            return {fontWeight:'bold'}
          }
        }
      },
      { title: "Expected.Total.Cost", field: "expected_total_cost", 
        cellStyle:(e,rowdata)=>{
          if(rowdata.last==1){
            return {fontWeight:'bold'}
          }
        }
      }
            ]}
            data={
                reportData
            }
             title={reportName}
            options={{
                actionsColumnIndex: -1,
                addRowPosition: "first",
                pageSize:10,
                loadingType: 'linear',
                paging: false,
                exportButton: true,
                maxBodyHeight: '500px',
                headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
                rowStyle: rowData => ({
                  backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
                })
              }}
             
          />

          <div>
      

{/* <div className="closeIconCSSTakeRate"> 
<CloseIcon className='closeIcon' onClick={handleClose}/>
</div> */}
{showSummaryDiv &&
<div style={style} className="parent">
{summary.length>0 &&
<>

<div  className='column column1'>
<span><b>Actual FM Cost: </b></span>

<br></br>
<span><b>{"$"+summary[0]['actual_fm_cost']}</b></span>

</div>
<div  className='column column2'>
<span><b>Expected Cost: </b></span>
<br></br>
<span><b>{"$"+summary[0]['total_cost']}</b></span>



</div>
<div  className='column column3'>
<span><b>Difference: </b></span>
<br></br>
<span><b>{"$"+summary[0]['diff']} </b></span>


</div>







</>
}




</div>
}








          </div>
          </>

        
        }
        </section>
       
      </div>

    )
}



function roundToTwo(num) {    
  return +(Math.round(num + "e+2")  + "e-2");
}

export default FirstmileCostAnalysis
